import { RequestDataDto } from "./request-data.dto";

export class ActionCommandResponseDto{
    shouldFetchData : boolean = false;
    requestData: RequestDataDto;
    constructor(partial: Partial<ActionCommandResponseDto>) {
        Object.assign(this, partial);
    }
}